Customer.Dashboard ||= {}

class Customer.Dashboard.TicketDetailsUserView extends Backbone.View

  initialize: (@options = {}) ->
    @interaction = @options.interaction
    @mergeCandidates = @options.mergeCandidates
    @userProfileResponse = @options.userProfileResponse

  render: (onFinish = ->) ->
    return @ unless @interaction
    if @interaction.starting_interaction
      errorMessage = I18n.t('user_profiles.starting_interaction')

    if @userProfilePreviewView
      @stopListening(@userProfilePreviewView)

    @userProfilePreviewView ||= new Customer.Users.UserProfilePreviewView
      source: @interaction.type
      id: @interaction.id
      session: 'customer',
      mergeCandidates: @mergeCandidates,
      errorMessage: errorMessage,
      userProfileResponse: @userProfileResponse
    @listenTo(@userProfilePreviewView,  'profile:cleared_candidates', => @trigger('profile:cleared_candidates'))
    @listenTo(@userProfilePreviewView,  'recalculate:merge:candidates', =>
      @trigger('recalculate:merge:candidates')
    )

    @userProfilePreviewView.render()
    @$el.html(@userProfilePreviewView.el)
    @listenToOnce(@userProfilePreviewView, 'render_finished', (response) => onFinish())
    @userProfilePreviewView.show()
    @

  updateCandidateCount: (count) ->
    @mergeCandidates = count
    @userProfilePreviewView.updateCandidateCount(@mergeCandidates) if @userProfilePreviewView?

  validateFieldsAreFilled: (fields) ->
    @userProfilePreviewView.validateFieldsAreFilled(fields)

  isBeingModified: ->
    return false unless @userProfilePreviewView?
    @userProfilePreviewView.isBeingModified()

  delegateEvents: ->
    return super() unless @interaction
    @userProfilePreviewView.delegateEvents() if @userProfilePreviewView
    super()

  clearCache: ->
    @userProfilePreviewView.response = undefined

  setuserProfileResponse: (userProfileResponse) =>
    @userProfileResponse = userProfileResponse
    @userProfilePreviewView?.setuserProfileResponse(userProfileResponse)

  onAttributesValidationError: (userProfileAttributeErrors) =>
    @userProfilePreviewView?.onAttributesValidationError(userProfileAttributeErrors)

  onTicketClose: =>
    @userProfilePreviewView?.onTicketClose()
